var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.666666666666668 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#bfd1e6",
    r: 6,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    calcMode: "spline",
    begin: "-0.4s",
    type: "scale",
    attributeName: "transform"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.333333333333336 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#5288bb",
    r: 6,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    calcMode: "spline",
    begin: "-0.3s",
    type: "scale",
    attributeName: "transform"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#243b51",
    r: 6,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    calcMode: "spline",
    begin: "-0.2s",
    type: "scale",
    attributeName: "transform"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.66666666666667 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#3e3a66",
    r: 6,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    calcMode: "spline",
    begin: "-0.1s",
    type: "scale",
    attributeName: "transform"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.33333333333333 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#bfd1e6",
    r: 6,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    calcMode: "spline",
    begin: "-0.0001s",
    type: "scale",
    attributeName: "transform"
  }))), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingDraft);
export default __webpack_public_path__ + "static/media/loading-draft.fe5197e8a8db210bb513dd2edda3b647.svg";
export { ForwardRef as ReactComponent };